import { XUtils } from '../common/globals'

export const ROOM_ID = XUtils.q2o(location.search.slice(1)).roomId || 31
export const EMOJI_TYPE_MAP = {
  //表情类别
  //"wzniu"  : { id:1, value : "wzniu",   name : "小牛哈哈",  icon : "https://staticcdn-prd.pydp888.com/room/v1.1/img/emojo_dk2.png" },
  //"dkface"  : { id:2, value : "dkface",   name : "斗K牛",  icon : "https://staticcdn-prd.pydp888.com/room/v1.1/img/emojo_dk1.png" },
  flower1: {
    id: 3,
    value: 'flower1',
    name: '二花二',
    icon: 'https://staticcdn-prd.pydp888.com/room/v1.1/img/emojo_fw1.png'
  },
  flower2: {
    id: 4,
    value: 'flower2',
    name: '二花五',
    icon: 'https://staticcdn-prd.pydp888.com/room/v1.1/img/emojo_fw2.png'
  },
  flower3: {
    id: 5,
    value: 'flower3',
    name: '二花的一天',
    icon: 'https://staticcdn-prd.pydp888.com/room/v1.1/img/emojo_fw3.png'
  }
  //"yxface"  : { id:6, value : "yxface",   name : "游学", icon : "https://staticcdn-prd.pydp888.com/room/v1.1/img/emojo_yx1.png"},
  //"beautiful" : { id:7, value : "beautiful", name : "优选", icon : "https://staticcdn-prd.pydp888.com/room/v1.1/img/emojo_bt1.png"}
}
export const EMOJI_FACE_XS = 'EMOJI_FACE_XS'
export const EMOJI_FACE_VERSION = '1000'
